/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../Fixes';
import Builder from '../../../Builder';
import '../api/verify';
import '../common/common';
import '../../payments/common';
import './auth';
import '../api/common';
import './gateway';
import '../common/metadata';
import '../common/scheme';
import '../../common/gateways';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "esperanto": {
        "nested": {
          "model": {
            "nested": {
              "VerificationIntent": {
                "fields": {
                  "createdAtMs": {
                    "type": "int64",
                    "id": 1,
                    "rule": "optional"
                  },
                  "cardOnFileUse": {
                    "type": ".squareup.esperanto.api.VerificationRequest.CardOnFileUse",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              },
              "VerificationResult": {
                "fields": {
                  "createdAtMs": {
                    "type": "int64",
                    "id": 1,
                    "rule": "optional"
                  },
                  "accountVerificationResult": {
                    "type": ".squareup.esperanto.api.AccountVerificationResult",
                    "id": 2,
                    "rule": "optional"
                  },
                  "avsVerificationResult": {
                    "type": ".squareup.esperanto.api.AvsVerificationResult",
                    "id": 3,
                    "rule": "optional"
                  },
                  "cvvVerificationResult": {
                    "type": ".squareup.esperanto.api.CvvVerificationResult",
                    "id": 4,
                    "rule": "optional"
                  },
                  "cardCapability": {
                    "type": ".squareup.esperanto.api.VerificationResponse.CardCapability",
                    "id": 5,
                    "rule": "repeated"
                  },
                  "declineRetryCategory": {
                    "type": ".squareup.esperanto.common.DeclineRetryCategory",
                    "id": 6,
                    "rule": "optional"
                  },
                  "adviceCode": {
                    "type": ".squareup.esperanto.common.AdviceCode",
                    "id": 7,
                    "rule": "optional"
                  },
                  "cardNetwork": {
                    "type": ".squareup.payments.common.CardNetwork",
                    "id": 8,
                    "rule": "optional"
                  },
                  "selectedAcquirer": {
                    "type": ".squareup.payments.common.AcquiringEntity",
                    "id": 9,
                    "rule": "optional"
                  },
                  "authenticationResponseData": {
                    "type": ".squareup.esperanto.common.AuthenticationResponseData",
                    "id": 10,
                    "rule": "optional"
                  },
                  "computedVerificationSloSuccessIndicator": {
                    "type": "bool",
                    "id": 11,
                    "rule": "optional"
                  }
                }
              },
              "CardVerification": {
                "fields": {
                  "intent": {
                    "type": ".squareup.esperanto.model.VerificationIntent",
                    "id": 1,
                    "rule": "optional"
                  },
                  "result": {
                    "type": ".squareup.esperanto.model.VerificationResult",
                    "id": 2,
                    "rule": "optional"
                  },
                  "tender": {
                    "type": ".squareup.esperanto.model.Tender",
                    "id": 3,
                    "rule": "optional"
                  },
                  "merchant": {
                    "type": ".squareup.esperanto.api.Merchant",
                    "id": 4,
                    "rule": "optional"
                  },
                  "gatewayData": {
                    "type": ".squareup.esperanto.model.GatewayData",
                    "id": 5,
                    "rule": "optional"
                  },
                  "debuggingInfo": {
                    "type": ".squareup.esperanto.api.VerificationDebuggingInfo",
                    "id": 6,
                    "rule": "optional"
                  },
                  "performedExperimentMetadata": {
                    "type": ".squareup.esperanto.common.PerformedExperimentMetadata",
                    "id": 7,
                    "rule": "optional"
                  },
                  "networkSequenceIdentifier": {
                    "type": "string",
                    "id": 8,
                    "rule": "optional"
                  },
                  "schemeData": {
                    "type": ".squareup.esperanto.common.SchemeData",
                    "id": 9,
                    "rule": "optional"
                  },
                  "targetGateway": {
                    "type": ".squareup.common.gateways.GatewayName",
                    "id": 10,
                    "rule": "optional"
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.esperanto?.nested?.model?.nested?.VerificationIntent && !$root.nested?.squareup?.nested?.esperanto?.nested?.model?.nested?.VerificationResult && !$root.nested?.squareup?.nested?.esperanto?.nested?.model?.nested?.CardVerification) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE VerificationIntent @ squareup/esperanto/model/verification.proto at 17:1
 */
export const VerificationIntent = $root.lookupType('squareup.esperanto.model.VerificationIntent');
fixType(VerificationIntent);
Builder.createAndAttachToType(VerificationIntent);
/**
 * SOURCE VerificationResult @ squareup/esperanto/model/verification.proto at 28:1
 */
export const VerificationResult = $root.lookupType('squareup.esperanto.model.VerificationResult');
fixType(VerificationResult);
Builder.createAndAttachToType(VerificationResult);
/**
 * SOURCE CardVerification @ squareup/esperanto/model/verification.proto at 91:1
 */
export const CardVerification = $root.lookupType('squareup.esperanto.model.CardVerification');
fixType(CardVerification);
Builder.createAndAttachToType(CardVerification);